export const PusherInstanceName = {
  Primary: 'primary',
  Failover: 'failover'
};
